import * as React from "react";

type UseModalCloseEffectOptions = {
  onClose: () => void;
  enableOutsideClick?: boolean;
};

export function useModalCloseEffect({
  onClose,
  enableOutsideClick,
}: UseModalCloseEffectOptions) {
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: React.MouseEvent) => {
    if (
      enableOutsideClick &&
      wrapperRef.current &&
      e.target === wrapperRef.current
    ) {
      onClose();
    }
  };

  return { wrapperRef, handleOutsideClick };
}
